import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { Data } from './services/data';
import { formatDate } from './services/util';
var WeightSetHistory = /** @class */ (function () {
    function WeightSetHistory(data) {
        this.data = data;
        this.hide = new EventEmitter();
        this.columnsToDisplay = ['when', 'count', 'name', 'weight', 'reps', 'del', 'edit'];
    }
    WeightSetHistory.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.data.renderableChanges.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, this.data.getRecentWeightSets()];
                                    case 1:
                                        _a.history = _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        _a = this;
                        return [4 /*yield*/, this.data.getRecentWeightSets()];
                    case 1:
                        _a.history = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetHistory.prototype.deleteItem = function (item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.deleteWeightSet(item.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetHistory.prototype.formatDate = function (date) {
        return formatDate(date);
    };
    return WeightSetHistory;
}());
export { WeightSetHistory };
